<template>
  <NotificationTemplate
    :notification="notification"
    :showSubTitle="false"
  >
    <template #pic>
      <div class="label-pic is-yellow">
        <icon
          data="@icon/billing-notification.svg"
          class="label-pic__icon"
          :fill="true"
          color="var(--markingOrange-02)"
          width="var(--icon-24)"
          height="var(--icon-24)"
        />
      </div>
    </template>

    <template #title>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="500"
      >
        {{ title }}
      </BaseSubHeading>
    </template>
    <template #content>
      <BaseSubHeading
        size="medium"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
        className="notification__desc"
      >
        {{ description }}
      </BaseSubHeading>
    </template>
  </NotificationTemplate>
</template>

<script lang="ts" setup>
import { computed } from "vue"

import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"

import { Notification } from "@/models/Notification"

const props = defineProps<{
  notification: Notification
}>()

const reminderDays = computed(() => {
  return props.notification?.content?.reminderDays
})

const isBusinessTrial = computed(() => {
  return props.notification?.content?.isBusinessTrial
})

const title = computed(() => {
  return isBusinessTrial.value
    ? `Your AI Assistant Trial Ends in ${reminderDays.value} Days`
    : `Your free trial of the Business plan ends in ${reminderDays.value} days`
})

const description = computed(() => {
  return isBusinessTrial.value
    ? "Upgrade to Enterprise to keep access to all features."
    : "Subscribe now to keep access to all features."
})
</script>
